export default __webpack_public_path__ + "static/media/nike-logo.c80ce72d.png";